if (!window.Eurus.loadedScript.has('sx-b2b-product-grid.js')) {
  window.Eurus.loadedScript.add('sx-b2b-product-grid.js');

  // Dožene VŠECHNY rozpracované změny množství (debounce + běžící requesty) a resolvne,
  // až je vše v košíku. Použij před přechodem na /cart nebo na checkout, ať se stránka
  // načte se správnými počty. Bezpečnostní timeout, aby se navigace nikdy nezablokovala.
  window.sxB2BEnsureSynced = function () {
    return new Promise((resolve) => {
      document.dispatchEvent(new CustomEvent('sx-b2b:flush'));
      if (!window.sxB2BPending) {
        resolve();
        return;
      }
      const start = Date.now();
      const check = () => {
        if (!window.sxB2BPending || Date.now() - start > 6000) resolve();
        else requestAnimationFrame(check);
      };
      check();
    });
  };

  const registerSxB2BGridItem = () => {
    Alpine.data('xSxB2BGridItem', (variantId, initialQty) => ({
        qty: parseInt(initialQty, 10) || 0,
        draftQty: '',
        loading: false,          // pouze vizuální spinner na pozadí – NIKDY neblokuje ovládání
        inputFocused: false,
        dirty: false,            // uživatel má lokální změnu, kterou košík ještě nepotvrdil
        syncing: false,          // běží požadavek na košík (serializuje commity)
        needsRecommit: false,    // hodnota se změnila znovu, zatímco běžel commit
        commitTimer: null,
        commitDelay: 300,
        pendingRegistered: false, // přispívá do window.sxB2BPending, dokud změna není v košíku
        intentSeq: 0,             // roste s každou uživatelskou změnou (odliší ji od ořezu skladem)
        maxQty: Infinity,         // klientský strop = množství skladem (když je sklad hlídán)
        skipSelfSync: false,      // přeskočí re-sync vyvolaný VLASTNÍM commitem (bod 2)
        variantId: parseInt(variantId, 10),
        init() {
          this.readMaxQty();
          this.draftQty = String(this.qty);
          this.syncCartQty();
          document.addEventListener('eurus:cart:items-changed', () => this.onCartItemsChanged());
          // Vynucené dokončení rozpracované změny (např. před přechodem na košík/checkout).
          document.addEventListener('sx-b2b:flush', () => this.flushNow());
          const sectionId = this.$el.dataset.sectionId;
          const productUrl = this.$el.dataset.productUrl;
          const isProductPage = this.$el.dataset.productPage === 'true';
          if (sectionId && productUrl) {
            document.addEventListener(`eurus:product-card-variant-select:updated:${sectionId}:${productUrl}`, () => this.onVariantChange());
          }
          if (isProductPage && sectionId) {
            document.addEventListener(`eurus:product-page-variant-select:updated:${sectionId}`, () => this.onVariantChange());
          }
          this.getForm()?.addEventListener('change', () => this.onVariantChange());
        },
        // Klientský strop množství podle skladu (data-max-qty z Liquidu). Prázdné =
        // bez stropu (sklad se nehlídá / povolen prodej i po vyprodání). Umožní ořez
        // okamžitě, bez čekání na server.
        readMaxQty() {
          const raw = this.$el.dataset.maxQty;
          if (raw === undefined || raw === '') {
            this.maxQty = Infinity;
          } else {
            const n = parseInt(raw, 10);
            this.maxQty = isNaN(n) ? Infinity : Math.max(0, n);
          }
        },
        destroy() {
          // Zabraň úniku pending počítadla, když se komponenta odstraní (např.
          // překreslení gridu po filtru) uprostřed rozpracované změny.
          this.clearCommitTimer();
          this.unregisterPending();
        },
        onVariantChange() {
          // Přepnutí varianty zahodí rozpracované množství pro předchozí variantu.
          this.dirty = false;
          this.unregisterPending();
          this.clearCommitTimer();
          this.readMaxQty();
          this.syncCartQty();
        },
        getForm() {
          const formId = this.$el.dataset.productFormId;
          if (formId) {
            const formById = document.getElementById(formId);
            if (formById) return formById;
          }
          return (
            this.$refs.product_form ||
            this.$el.closest('form[data-type="add-to-cart-form"]') ||
            this.$el.closest('form')
          );
        },
        getVariantId() {
          const sectionId = this.$el.dataset.sectionId;
          const formInput = this.getForm()?.querySelector('[name="id"]');
          if (formInput?.value) return parseInt(formInput.value, 10);
          const variantInput = sectionId
            ? document.getElementById(`update-variant-${sectionId}`)
            : null;
          if (variantInput?.value) return parseInt(variantInput.value, 10);
          return this.variantId;
        },
        async fetchCartQty() {
          try {
            const response = await fetch(`${Shopify.routes.root}cart.js`);
            const cart = await response.json();
            const id = this.getVariantId();
            const item = cart.items.find((line) => line.variant_id === id);
            return item ? item.quantity : 0;
          } catch (error) {
            console.error(error);
            return this.qty;
          }
        },
        // Reakce na 'eurus:cart:items-changed'. Bod 2: událost vyvolanou VLASTNÍM
        // commitem přeskočíme – tahle karta už má aktuální stav z odpovědi update.js,
        // takže by se zbytečně znovu četla z cart.js (síťový šum + šance na race).
        onCartItemsChanged() {
          if (this.skipSelfSync) {
            this.skipSelfSync = false;
            return;
          }
          this.syncCartQty();
        },
        // Přečti autoritativní množství z košíku, ale NIKDY když má uživatel
        // neuloženou lokální změnu nebo právě něco dělá – jinak by input viditelně
        // skočil (např. na 0) a po dokončení commitu se zase vrátil.
        async syncCartQty() {
          if (this.dirty || this.inputFocused || this.syncing || this.commitTimer) return;
          try {
            const cartQty = await this.fetchCartQty();
            if (this.dirty || this.inputFocused || this.syncing || this.commitTimer) return;
            this.qty = cartQty;
            this.draftQty = String(cartQty);
            this.variantId = this.getVariantId();
          } catch (error) {
            console.error(error);
          }
        },
        onInputFocus() {
          this.inputFocused = true;
          this.clearCommitTimer();
          this.draftQty = String(this.qty);
        },
        onInputBlur(el) {
          let next = parseInt(el.value, 10);
          if (isNaN(next) || next < 0) {
            this.draftQty = String(this.qty);
            el.value = this.qty;
            this.inputFocused = false;
            return;
          }
          next = Math.floor(next);
          this.inputFocused = false;
          this.setQty(next);
        },
        // Optimistická lokální změna + odložený commit na pozadí. Ovládání se
        // nikdy nezablokuje, takže uživatel může dál klikat/psát bez čekání.
        setQty(value) {
          let next = value;
          // Klientský strop skladem: ořízni HNED, ať se do košíku pošle rovnou
          // maximální povolený počet (žádné čekání na serverovou korekci).
          if (next > this.maxQty) {
            next = this.maxQty;
            this.notifyStockCapped(this.maxQty);
          }
          // Optimisticky uprav počet u ikony košíku HNED při kliku o rozdíl množství
          // (commit ho pak srovná na skutečný stav z košíku).
          this.adjustCartCountBubble(next - this.qty);
          this.qty = next;
          this.draftQty = String(next);
          this.dirty = true;
          this.intentSeq += 1;
          this.registerPending();
          this.scheduleCommit();
        },
        // Globální počítadlo rozpracovaných změn (window.sxB2BPending) + reaktivní
        // příznak pro viditelný indikátor "aktualizuji košík". waitForCartUpdate()
        // i checkout na tento stav čekají.
        registerPending() {
          if (this.pendingRegistered) return;
          this.pendingRegistered = true;
          window.sxB2BPending = (window.sxB2BPending || 0) + 1;
          this.reflectSyncing();
        },
        unregisterPending() {
          if (!this.pendingRegistered) return;
          this.pendingRegistered = false;
          window.sxB2BPending = Math.max(0, (window.sxB2BPending || 0) - 1);
          this.reflectSyncing();
        },
        reflectSyncing() {
          const helper = Alpine.store('xCartHelper');
          if (helper) helper.cartSyncing = (window.sxB2BPending || 0) > 0;
        },
        // Optimistická úprava počtu u ikony o rozdíl (delta) – okamžitě při kliku +/-.
        // Čte aktuální počet z bubliny (data-value) a přičte delta; commit pak srovná
        // na skutečný cart.item_count.
        adjustCartCountBubble(delta) {
          const d = parseInt(delta, 10);
          if (!d) return;
          let current = null;
          const ids = ['cart-icon-bubble', 'mobile-cart-icon-bubble', 'cart-icon-bubble-mobile-dock'];
          for (let i = 0; i < ids.length; i++) {
            const el = document.getElementById(ids[i]);
            if (!el) continue;
            const countEl = el.classList.contains('count_item') ? el : el.querySelector('.count_item');
            const val = countEl && countEl.getAttribute('data-value');
            if (val != null && val !== '') {
              current = parseInt(val, 10);
              break;
            }
          }
          if (current === null || isNaN(current)) {
            const helper = Alpine.store('xCartHelper');
            current = (helper && helper.currentItemCount) || 0;
          }
          const nextCount = Math.max(0, current + d);
          this.updateCartCountBubble(nextCount);
          const helper = Alpine.store('xCartHelper');
          if (helper) helper.currentItemCount = nextCount;
        },
        // Přímá aktualizace počtu u ikony košíku (hlavička + mobilní bubliny). Nespoléhá
        // na překreslení sekce, takže počet naskočí hned – ne až po reloadu stránky.
        updateCartCountBubble(count) {
          const n = parseInt(count, 10);
          if (isNaN(n)) return;
          const text = n < 100 ? String(n) : '99+';
          ['cart-icon-bubble', 'mobile-cart-icon-bubble', 'cart-icon-bubble-mobile-dock'].forEach((id) => {
            const el = document.getElementById(id);
            if (!el) return;
            const countEl = el.classList.contains('count_item') ? el : el.querySelector('.count_item');
            if (!countEl) return;
            countEl.textContent = text;
            countEl.setAttribute('data-value', n);
            if (n > 0) countEl.classList.remove('hidden');
            else countEl.classList.add('hidden');
          });
        },
        minus() {
          if (this.qty <= 0) return;
          this.setQty(this.qty - 1);
        },
        plus() {
          this.setQty(this.qty + 1);
        },
        clearCommitTimer() {
          if (this.commitTimer) {
            clearTimeout(this.commitTimer);
            this.commitTimer = null;
          }
        },
        // Okamžitě commitni čekající (debounced) změnu – nečekat na 300ms okno.
        flushNow() {
          if (this.commitTimer) {
            this.clearCommitTimer();
            this.commit();
          }
        },
        scheduleCommit() {
          this.clearCommitTimer();
          this.commitTimer = setTimeout(() => {
            this.commitTimer = null;
            this.commit();
          }, this.commitDelay);
        },
        // Serializovaný commit: jen jeden požadavek na košík naráz. Když uživatel
        // mezitím množství změní, po dokončení se commitne znovu (platí poslední).
        async commit() {
          if (this.syncing) {
            this.needsRecommit = true;
            return;
          }
          this.syncing = true;
          this.loading = true;
          const seq = this.intentSeq;
          try {
            await this.setCartQty(this.qty, seq);
          } catch (error) {
            console.error(error);
          } finally {
            this.syncing = false;
            this.loading = false;
            // Recommit jen když uživatel zadal NOVOU hodnotu během commitu (intentSeq).
            // Ne když jsme jen ořízli qty na dostupné skladem – to je konečný stav.
            if (this.needsRecommit || this.intentSeq !== seq) {
              this.needsRecommit = false;
              // Bod 1: pošli novější hodnotu HNED, ne přes další 300ms okno (aby se
              // čekání nesčítalo a poslední záměr uživatele dorazil co nejdřív).
              // Zruš čekající naplánovaný commit, ať se pak nespustí podruhé nadarmo.
              this.clearCommitTimer();
              this.commit();
            } else {
              this.dirty = false;
              this.unregisterPending();
            }
          }
        },
        // Krátká hláška, když bylo množství oříznuto na dostupné skladem.
        notifyStockCapped(available) {
          let message = '';
          try {
            if (window.Eurus && window.Eurus.cart_quantity_error_html) {
              message = window.Eurus.cart_quantity_error_html.replace('[quantity]', available);
            }
          } catch (e) { /* ignore */ }
          if (!message) message = `Skladem je pouze ${available} ks.`;
          this.showStockToast(message);
        },
        showStockToast(html) {
          try {
            let toast = document.getElementById('sx-b2b-stock-toast');
            if (!toast) {
              toast = document.createElement('div');
              toast.id = 'sx-b2b-stock-toast';
              toast.setAttribute('role', 'status');
              toast.style.cssText =
                'position:fixed;z-index:9999;left:50%;bottom:24px;transform:translateX(-50%);' +
                'max-width:90vw;background:rgba(20,20,20,0.92);color:#fff;padding:10px 16px;' +
                'border-radius:8px;font-size:14px;line-height:1.4;box-shadow:0 4px 16px rgba(0,0,0,0.2);' +
                'opacity:0;transition:opacity .2s;pointer-events:none;';
              document.body.appendChild(toast);
            }
            toast.innerHTML = html;
            requestAnimationFrame(() => { toast.style.opacity = '1'; });
            clearTimeout(window.sxB2BStockToastTimer);
            window.sxB2BStockToastTimer = setTimeout(() => { toast.style.opacity = '0'; }, 3000);
          } catch (e) { /* ignore */ }
        },
        // Postranní notifikace "položka přidána do košíku" je pro B2B vypnutá (na přání).
        // Komponenta je B2B-only, takže stačí no-op. Pro obnovení vrať volání
        // Alpine.store('xCartNoti')?.setItem(item).
        showCartNoti() {},
        // Rychlá cesta pro stepper: jedno volání cart/update.js nastaví absolutní
        // množství (přidá i položku, která v košíku není), BEZ renderu sekcí.
        // Košíkové sekce (ikona, drawer, doprava zdarma) se obnoví na pozadí, takže
        // spinner skončí hned po zápisu a nečeká se na těžké překreslení.
        async setCartQty(qty, seq) {
          const variantId = this.getVariantId();
          if (!variantId) return;
          const target = Math.max(0, Math.floor(qty));

          // POZOR: nevoláme zde waitForCartUpdate() – ta teď čeká na window.sxB2BPending,
          // který drží právě tento probíhající commit → byl by to deadlock. Commity
          // serializuje vlastní 'syncing'.
          window.updatingCart = true;

          try {
            // JEDNO rychlé volání: cart/update.js nastaví absolutní množství a přidá i
            // položku, která v košíku není. Díky klientskému stropu (maxQty) posíláme vždy
            // platné množství, takže update.js normálně neselže. 422 (zastaralý sklad)
            // je jen pojistka – dočteme skutečný stav.
            let cart = await this.postCart('cart/update.js', { updates: { [variantId]: target } });

            if (!cart || cart.status == 422 || !Array.isArray(cart.items)) {
              cart = await fetch(`${Shopify.routes.root}cart.js`).then((res) => res.json()).catch(() => null);
            }

            // Bez platné odpovědi (síťová chyba) nech optimistickou hodnotu – srovná se později.
            if (!cart || !Array.isArray(cart.items)) return;

            const line = cart.items.find((l) => l.variant_id == variantId);

            const realQty = line ? line.quantity : 0;
            const helper = Alpine.store('xCartHelper');
            if (helper && typeof cart.item_count === 'number') helper.currentItemCount = cart.item_count;
            // Okamžitě aktualizuj počet u ikony košíku (nespoléhat na debounced překreslení sekce).
            if (typeof cart.item_count === 'number') this.updateCartCountBubble(cart.item_count);
            if (line) this.showCartNoti(line);

            // PRIMÁRNÍ OPRAVA (race): serverovou hodnotu zapiš do inputu JEN když uživatel
            // mezitím neklikl (intentSeq beze změny). Jinak by se jeho novější číslo přepsalo
            // starým potvrzeným (to je ono "číslo se vrací"); novější hodnotu dožene recommit.
            const intentUnchanged = this.intentSeq === seq;
            if (intentUnchanged && !this.inputFocused) {
              this.qty = realQty;
              this.draftQty = String(realQty);
            }
            if (intentUnchanged && target > 0 && realQty < target) this.notifyStockCapped(realQty);

            // Bod 2: přeskočit re-sync vyvolaný tímhle vlastním dispatch.
            this.skipSelfSync = true;
            document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
            this.refreshCartSurfaces();
          } catch (error) {
            console.error(error);
            this.dirty = false;
            await this.syncCartQty();
          } finally {
            window.updatingCart = false;
          }
        },
        postCart(path, body) {
          return fetch(`${Shopify.routes.root}${path}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body)
          })
            .then((res) => res.json())
            .catch(() => null);
        },
        // Obnoví košíkové sekce (ikona, drawer, doprava zdarma) na pozadí – SDÍLENĚ a
        // ODLOŽENĚ. Při rychlé změně množství u více produktů se drawer (renderuje VŠECHNY
        // položky košíku) překreslí JEDNOU po ustálení, ne po každé změně. Právě N těžkých
        // překreslení DOM na hlavním vlákně způsobovalo sekání a nereagující ovládání.
        refreshCartSurfaces() {
          clearTimeout(window.sxB2BSurfaceTimer);
          window.sxB2BSurfaceTimer = setTimeout(() => {
            try {
              const helper = Alpine.store('xCartHelper');
              if (helper && typeof helper.reRenderSections === 'function') {
                Promise.resolve(helper.reRenderSections()).catch(() => {});
              }
            } catch (e) {
              /* pozadí – ignorovat */
            }
          }, 450);
        },
        async addToCart(e) {
          await this.addToCartWithQty(1, e);
        },
        async addToCartWithQty(qty, e) {
          if (e) e.preventDefault();
          const variantId = this.getVariantId();
          if (!variantId) return;

          await Alpine.store('xCartHelper').waitForCartUpdate();
          window.updatingCart = true;

          const formData = new FormData();
          formData.append('id', variantId);
          formData.append('quantity', qty);
          formData.append(
            'sections',
            Alpine.store('xCartHelper').getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);

          try {
            const response = await fetch(`${Eurus.cart_add_url}`, {
              method: 'POST',
              headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
              body: formData
            }).then((res) => res.json());

            if (response.status === '422') {
              this.dirty = false;
              await this.syncCartQty();
            } else {
              this.showCartNoti(response);
              // Na stránce kolekce se překreslují jen košíkové sekce (bubble +
              // drawer), NE produktový grid – karta se tedy nepřestaví.
              Alpine.store('xCartHelper').reRenderSections(response.sections);
              Alpine.store('xCartHelper').currentItemCount = parseInt(
                document.getElementById('cart-icon-bubble').innerHTML
              );
              // Nepřepisuj qty, pokud uživatel mezitím hodnotu posunul dál.
              if (!this.inputFocused && this.qty === qty) this.draftQty = String(qty);
              document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
            }
          } catch (error) {
            console.error(error);
          } finally {
            window.updatingCart = false;
          }
        },
        async updateQtyInCart(qty) {
          const variantId = this.getVariantId();
          const updateData = {
            id: `${variantId}`,
            quantity: `${qty}`,
            sections: Alpine.store('xCartHelper').getSectionsToRender().map((s) => s.id),
            sections_url: window.location.pathname
          };

          try {
            const response = await fetch(`${Shopify.routes.root}cart/change.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(updateData)
            }).then((res) => res.json());

            if (response.status === '422') {
              this.dirty = false;
              await this.syncCartQty();
            } else {
              const changedItem = (response.items || []).find(
                (line) => line.variant_id == variantId || line.id == variantId
              );
              if (changedItem) this.showCartNoti(changedItem);
              Alpine.store('xCartHelper').reRenderSections(response.sections);
              Alpine.store('xCartHelper').currentItemCount = parseInt(
                document.getElementById('cart-icon-bubble').innerHTML
              );
              if (!this.inputFocused && this.qty === qty) this.draftQty = String(qty);
              document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
            }
          } catch (error) {
            console.error(error);
          }
        }
      }));
  };

  if (window.Alpine) {
    registerSxB2BGridItem();
  } else {
    document.addEventListener('alpine:init', registerSxB2BGridItem);
  }
}
